const _ = require('lodash');
const buyGSOnlineMapper = require('./atmmapper/online-buy-gs-mapper');
module.exports = function (trolleyService, $rootScope, atm, bwsNotificationService, $stateParams, shopperService, decorateAdditionalDetails, collectionTimeService, $uibModal, storePickerService, $location, shopLocatorService) {
    return {
        restrict: 'E',
        scope: {
            product: '=',
            onUpdate: '&?',
            onSuccess: '&?',
            onError: '&?',
            autoUpdate: '@?',
            useTrolleyQuantity: '@?',
            productCollection: '=',
            area: '@?',
            googleShopping: '=',
            googleShoppingDetails: '=',
            regionId: '=',
            defaultProductCode: '='
        },
        link($scope) {
            let modalInstance = null;
            $scope.$uibModal = $uibModal;
            $scope.trolleyService = trolleyService;
            $scope.storePickerService = storePickerService;
            $scope.autoUpdate = ($scope.autoUpdate || 'false') === 'true';
            $scope.useTrolleyQuantity = false;
            $scope.fulfilmentStoreName = storePickerService.store.FulfilmentStoreName;
            $scope.minimumQuantity = $scope.product.MinimumQuantity || 1;
            $scope.adId = $scope.product.adId || $scope.product.AdId;
            $scope.gsProduct = {};
            $scope.availableTrolleyItems = null;
            $scope.isSystemAddress = $scope.storePickerService.fulfilmentInfo.IsSystemAddress ? $scope.storePickerService.fulfilmentInfo.IsSystemAddress : null;
            if ($scope.googleShoppingDetails) {
                // show the PackDefaultStockCode prices
                $scope.gsProduct = $scope.googleShoppingDetails.Products.find(product => product.Stockcode === $scope.defaultProductCode);
            }
            function setQuantity() {
                let trolleyItem;
                if ($scope.itemInTrolley) {
                    trolleyItem = trolleyService.getTrolleyItem($scope.itemInTrolley.Stockcode);

                    if (trolleyItem && trolleyItem.Quantity) {
                        return trolleyItem.Quantity;
                    }
                }

                return $scope.product.DisplayQuantity > 0 ?
                        $scope.product.DisplayQuantity : $scope.minimumQuantity;
            }
            function setControlsTotalPrice() {
                return $scope.itemInTrolley !== undefined ? $scope.itemInTrolley.Price * $scope.itemInTrolley.QuantityInTrolley : $scope.product.Price;
            }

            function _init() {
                if ($scope.productCollection) {

                    $scope.itemInTrolley = _.find($scope.productCollection.Products, { IsInTrolley: true });

                    //If we have clicked on a product in a product group
                    if ($stateParams.overwriteDefaultProduct && $scope.area === 'detail') {
                        $scope.productCollection.defaultProduct = _.find($scope.productCollection.Products, { Stockcode: $stateParams.overwriteDefaultProduct });
                    }

                    if ($scope.area === 'detail') {
                        $scope.parentProduct = _.find($scope.productCollection.Products, { Stockcode: $scope.productCollection.PackParentStockCode });
                        decorateAdditionalDetails([$scope.parentProduct]);
                    }
                    if ($scope.googleShopping || $location.search().pack_type) {
                        $scope.selectedProduct = _.find($scope.productCollection.Products, { Stockcode: $scope.defaultProductCode });
                    } else {
                        $scope.selectedProduct = $scope.itemInTrolley !== undefined ?
                        $scope.itemInTrolley : $scope.productCollection.defaultProduct;
                    }
                    $scope.quantity = setQuantity();

                    if ($scope.itemInTrolley) {
                        $scope.product = $scope.itemInTrolley;
                        $scope.$emit('productFamily:update', { product: $scope.product, qty: $scope.quantity });
                    }
                    $scope.$emit('trolleyControls:update', $scope.quantity);

                    $scope.controlsTotalPrice = setControlsTotalPrice();
                }
            }

            _init();
            $scope.buyOnlineWithGSStore = () => {
                shopLocatorService.getAvailableTrolleyItems($scope.regionId)
                .then((response) => {
                    if (response && response.Success) {
                        $scope.availableTrolleyItems = response;
                    }
                });
                modalInstance = $scope.$uibModal.open({
                    animation: true,
                    templateUrl: 'bo-gsstore-modal',
                    scope: $scope,
                    size: 'lg',
                    windowClass: 'gs gs-store-modal'
                });
                atm.push('google shop:google advertised price:buy online', buyGSOnlineMapper);
            };
            $scope.priceDiffInfo = () => {
                modalInstance = $scope.$uibModal.open({
                    animation: true,
                    templateUrl: 'price-diff-modal',
                    scope: $scope,
                    size: 'lg',
                    windowClass: 'gs gs-store-modal'
                });
                atm.push('google shop:why is this price different', buyGSOnlineMapper);
            };
            $scope.closePopup = () => {
                modalInstance.dismiss('cancel');
            };
            $scope.navigateToProduct = () => {
                const productUrl = $location.path();
                $location.path(productUrl).search({ pack_type: 'true' });
                $scope.googleShopping = false;
                $scope.googleShoppingDetails = null;
                $scope.$emit('showGoogleShopping:update', true);
            };

            $scope.buyOnlineAndSetStore = () => {
                $scope.storePickerService.setPickupByStoreNo($scope.storePickerService.store.FulfilmentStoreID).then(() => {
                    $scope.navigateToProduct();
                });
                atm.push('google shop:my preference:buy online', buyGSOnlineMapper);
            };
            $scope.continueAndUpdate = () => {
                atm.push('google shop:google advertised price:continue and update', buyGSOnlineMapper);
                $rootScope.isGoogleProduct = true;
                $scope.storePickerService.setPickupByStoreNo($scope.regionId).then(() => {
                    $scope.closePopup();
                    $scope.navigateToProduct();
                    bwsNotificationService.success(`You’re browsing BWS ${$scope.storePickerService.fulfilmentInfo.ClickAndCollectDetails.FulfilmentStoreName}`);
                });
            };
            $scope.setButtonsState = function () {
                const minQty = $scope.product.MinimumQuantity;
                const inValid = isNaN($scope.quantity);
                const quantity = $scope.quantity;
                const quantityInTrolley = $scope.product.QuantityInTrolley || 0;

                // Add button is disabled if value is not within the correct range;
                $scope.isDisabled = inValid
                    || quantity < minQty
                    || ($scope.isInTrolley && quantity === quantityInTrolley);

                // Decrement button disabled if quantiy is less than or equal to minium quantity
                $scope.isDecrementDisabled = quantity <= minQty || inValid;
            };

            function updateTrolleyItem() {

                if ($scope.onUpdate) {
                    $scope.onUpdate();
                }

                // Attempt update
                $scope.product.adId = $scope.product.adId || $scope.adId;
                $scope.trolleyService.updateTrolleyItem($scope.product, $scope.quantity, $scope.area).then(function () {
                    if ($scope.onSuccess) {
                        $scope.onSuccess();
                    }
                });
            }

            $scope.update = $scope.autoUpdate ? _.debounce(updateTrolleyItem, 200) : updateTrolleyItem;

            function checkMaxPurchaseQty() {

                const maxPurchaseQuantity = parseInt($scope.product.ProductData.maxpurchasequantity) || $scope.product.SupplyLimit;

                if ($scope.quantity >= maxPurchaseQuantity && $scope.area === 'detail' && !shopperService.IsImpersonate) {
                    $scope.supplyLimitReached = true;
                    $scope.quantity = maxPurchaseQuantity;
                } else {
                    $scope.supplyLimitReached = false;
                }
            }

            function getProductBackOrderStockOnHand() {
                $scope.productStockOnHand = $scope.product.BackorderStockOnHand > ($scope.product.ProductData.maxpurchasequantity || $scope.product.SupplyLimit) ? ($scope.product.ProductData.maxpurchasequantity || $scope.product.SupplyLimit) : $scope.product.BackorderStockOnHand + $scope.product.StockOnHand;
            }


            function validateTrolleyQuantity() {

                if (!$scope.trolleyService.validateQuantity($scope.product, $scope.quantity, $scope.product.QuantityInTrolley)) {

                    $scope.quantity = $scope.product.QuantityInTrolley;

                    if ($scope.onError) {
                        $scope.onError();
                    }
                } else {

                    checkMaxPurchaseQty();

                   $scope.product.QuantityInTrolley = $scope.quantity;

                    if ($scope.autoUpdate) {
                        $scope.update();
                    } else {
                        if ($scope.onUpdate) {
                            $scope.onUpdate();
                        }
                    }
                }
                $scope.setButtonsState();
                getProductBackOrderStockOnHand();

                $scope.product.DisplayQuantity = $scope.quantity;
                const maxPurchaseQuantity = parseInt($scope.product.ProductData.maxpurchasequantity) || $scope.product.SupplyLimit;
                const stockOnHand = $scope.product.StockOnHand;
                const totalStockOnHand = $scope.product.StockOnHand + $scope.product.BackorderStockOnHand;

                const backOrderCollectionTime = collectionTimeService.calculateBackorderPickupDate();

                const pluralizePackSize = $scope.product.StockOnHand > 1 ? 's' : '';
                const pluralizeNoun = $scope.product.StockOnHand || $scope.product.BackorderStockOnHand > 1 ? 'are' : 'is';

                bwsNotificationService.clearAll();

                if ($scope.product.QuantityInTrolley > maxPurchaseQuantity) {
                    bwsNotificationService.info('Sorry, a purchase limit of ' + maxPurchaseQuantity + ' applies to this product');
                } else if ($scope.product.QuantityInTrolley > totalStockOnHand) {
                    bwsNotificationService.info(`Sorry, only ${totalStockOnHand} is available to purchase.`);
                } else if ($scope.product.QuantityInTrolley > stockOnHand && stockOnHand !== 0 && $scope.product.BackorderStockOnHand !== 0 && $scope.area === 'cart') {
                    bwsNotificationService.info(`${stockOnHand} <span class='text-lowercase'>${$scope.product.ProductData.webpacktype}</span>${pluralizePackSize} available to pick up now, order up to ${$scope.productStockOnHand} and pick up by ${backOrderCollectionTime}.`);
                } else if (stockOnHand === 0 && $scope.product.BackorderStockOnHand !== 0 && $scope.area === 'cart') {
                    bwsNotificationService.info(`This item is currently unavailable, order up to ${$scope.productStockOnHand} <span class='text-lowercase'>${$scope.product.ProductData.webpacktype}</span>${pluralizePackSize} and pick up by ${backOrderCollectionTime}.`);
                } else if ($scope.product.QuantityInTrolley > $scope.product.StockOnHand && $scope.product.BackorderStockOnHand === 0) {
                    bwsNotificationService.info(`Sorry, only ${$scope.product.StockOnHand} <span class='text-lowercase'>${$scope.product.ProductData.webpacktype}</span>${pluralizePackSize} ${pluralizeNoun} available.`);
                }
            }

            $scope.sortByUnitQuantity = function () {
                return function (object) {
                    if (object.ProductData && object.ProductData.productunitquantity) {
                        return parseInt(object.ProductData.productunitquantity);
                    }
                    return 0;
                };
            };

            $scope.updateTextInput = function (quantity) {
                if (quantity) {
                    //ToDO: remove the line below if not required
                    $scope.updateQtyByKeyboard(quantity);

                    $scope.updateQuantity(quantity);
                }
            };

            $scope.updateQuantity = function (newQuantity) {
                if (typeof (newQuantity) !== 'undefined' && newQuantity !== '') {
                    //setter
                    $scope.quantity = newQuantity;

                    if ($scope.product) {
                        $scope.product.DisplayQuantity = newQuantity;
                    }

                    validateTrolleyQuantity();
                }

                // If the user enters empty string (e.g by backspacing) don't submit because it will remove the product from the trolley.
                // Still show an enpty string though.
                if (!newQuantity) {
                    $scope.quantity = $scope.minimumQuantity;
                    $scope.setButtonsState();
                }
                //generateSrNotification(quantity);

                return $scope.quantity;
            };

            function updateTotal(qty) {
                return $scope.product.Price * qty;
            }
            $scope.toggleCheckStockPopup = function () {
                modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'find-me-nearby',
                    scope: $scope,
                    size: 'lg'
                });
            };
            $scope.closePopup = function (state) {
                modalInstance.dismiss('cancel');
            switch (state) {
                case 'goback':
                    atm.push('google shop:google advertised price:go back', buyGSOnlineMapper);
                    break;
                case 'close':
                    atm.push('google shop:google advertised price:cross button', buyGSOnlineMapper);
                    break;
            }

            };
            $scope.updateQtyByKeyboard = function (newQuantity) {

                $scope.controlsTotalPrice = updateTotal($scope.quantity);

                if ($scope.product) {
                    $scope.product.DisplayQuantity = newQuantity;
                }

                $scope.$emit('trolleyControls:update', newQuantity);

                if ($scope.autoUpdate) {
                    $rootScope.$broadcast('cart:autoUpdate', $scope.quantity, $scope.product);
                }
            };

            $scope.increment = function () {
                if (!$scope.isIncrementDisabled) {
                    $scope.updateQuantity($scope.quantity + 1);
                    $scope.controlsTotalPrice = updateTotal($scope.quantity);

                    $scope.$emit('trolleyControls:update', $scope.quantity);
                }

                if ($scope.autoUpdate) {
                    $rootScope.$broadcast('cart:autoUpdate', $scope.quantity, $scope.product);
                }
            };

            $scope.decrement = function () {
                const newQuantity = $scope.quantity - 1;
                if (newQuantity >= $scope.minimumQuantity) {
                    $scope.updateQuantity(newQuantity);
                    $scope.controlsTotalPrice = updateTotal(newQuantity);

                    $scope.$emit('trolleyControls:update', $scope.quantity);
                }

                if ($scope.autoUpdate) {
                    $rootScope.$broadcast('cart:autoUpdate', $scope.quantity, $scope.product);
                }
            };
            let productFamilyListener;

            $scope.selectProductFamilyMember = function (product) {
                product.DisplayQuantity = $scope.quantity;
                $scope.product = product;

                if ($scope.autoUpdate) {
                    $rootScope.$broadcast('productFamily:update', { product: $scope.product, qty: $scope.quantity });
                }

                $scope.selectedProduct = product;

                $scope.$emit('trolleyControls:update', $scope.quantity);

                $scope.$emit('productFamily:update', { product: $scope.product, qty: $scope.quantity });

                $scope.controlsTotalPrice = $scope.product.Price * $scope.quantity;

                $scope.updateQuantity($scope.quantity);

                checkMaxPurchaseQty();

                if ($scope.autoUpdate) {

                    productFamilyListener = $scope.$emit('productFamily:cartUpdated', { area: $scope.area, product });
                    updateTrolleyItem();
                }
                if ($scope.googleShopping) {
                    $scope.gsProduct = $scope.googleShoppingDetails.Products.find(item => item.Stockcode === $scope.selectedProduct.Stockcode);
                }
            };

            $scope.$on('$destroy', productFamilyListener);

            $scope.$watch('product.QuantityInTrolley', function (quantity) {
                if (quantity && quantity > 0) {
                    $scope.quantity = quantity;
                    $scope.controlsTotalPrice = updateTotal(quantity);
                } else {
//                    $scope.quantity = $scope.minimumQuantity;
                    $scope.controlsTotalPrice = updateTotal($scope.quantity);
                }
            });

            $rootScope.$on('trolley:update', function (event, data) {

                if ($scope.IsInTrolley && ($scope.area !== 'detail')) {
                    $scope.quantity = setQuantity();
                    if ($scope.product) {
                        $scope.product.DisplayQuantity = $scope.quantity;
                        $scope.$emit('trolleyControls:update', $scope.quantity);
                    }
                }

                if (data && data.response) {
                    const product = _.find(data.response.AvailableItems, { ParentStockcode: $scope.product.ParentStockCode });

                    if (!_.isUndefined(product)) {
                        const quantity = product.Quantity;
                        if (quantity) {
                            $scope.quantity = quantity;
                            if ($scope.product) {
                                $scope.product.DisplayQuantity = quantity;
                                $scope.$emit('trolleyControls:update', quantity);
                            }
                        }

                        $scope.selectedProduct = product;
                    }
                }

            });

        },
        template: require('./trolleycontrols-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/trolleycontrols-directive.js
 **/